<template>
  <div class="product-line-item-container flex-row-reverse r-legacy-form">
    <div class="pli-second-container" aria-atomic="true" aria-live="polite">
      <div :class="[
        'pli-product-details-and-price',
        isBoxProduct ? 'gift-box' : ' ',
      ]">
        <div class="pli-product-details">
          <div class="pli-product-name">
            <div>
              <span v-if="isOutOfStock" class="pli-out-of-stock">
                <span v-html="$t('cart.out.of.cart')"></span>
              </span>
              <span v-if="isMaxQuantityExceed" class="pli-max-quantity-exceeded">
                <span v-html="$t('cart.maximum.quantity.exceeded')"></span>
              </span>
              <span v-if="isPriceMissing" class="pli-out-of-stock">
                <span v-html="$t('cart.item.notavailable')"></span>
              </span>
            </div>
            <a :class="` ${isBoxProduct || isSample || isBonusProduct || isOnCheckoutPage ? 'pli-disabled' : ''}`"
              v-if="!isBoxProduct" :href="isSample || isBonusProduct ? '/' : product.url"
              :aria-label="!isSample && !isBonusProduct ? product.productName + (product.priceTotal.nonAdjustedPrice ? ' ' + $t('reduced.from') + ' ' +  product.priceTotal.nonAdjustedPrice + ' ' + $t('reduced.to') + ' ' + product.priceTotal.price : '') : null"
                >{{
                product.productName
              }}</a>
            <span v-else>
                {{ $t('byos.productto', [`${box.byosBoxName}`]) }}
            </span>
          </div>

          <!-- ProductAttributes -->
          <div v-for="attribute in product.variationAttributes" :key="attribute.name"
            class="pli-product-attributes font-weight-light">
            {{ attribute.displayName }}: {{ attribute.displayValue }}
          </div>

          <div v-if="isOnCheckoutPage" class="pli-product-attributes font-weight-light"
            v-html="`${$t('global.qty')} ${realProductQty}`"></div>

          <div v-if="isBoxProduct" class="pli-product-attributes font-weight-light content">
            <div v-for="productName in box.boxedProductNames" :key="productName">
              {{ productName }}
            </div>
          </div>
          <!-- ProductAttributes -->

          <!-- ProductSORCheckoutMiniCart-->
          <div
            v-if="isOnCheckoutPage && SorEnabled && product.hasSmartOrderRefill && product.SorMonthInterval > 0 && ((!cart.isFreshEmployee && !cart.isLVMHEmployee) || (((cart.isFreshEmployee && cart.isMemeberOfEmployeeDiscountCustomerGroup) || cart.isLVMHEmployee) && allowEmployeeForReplenishment))"
            class="osf-subscribe-mini-cart" v-html="$t('smartorderrefill.sorproduct.subscription.message')">
          </div>
          <!-- ProductSORCheckoutMiniCart-->

          <!-- ProductPromotions -->
          <div v-if="
            product.appliedPromotions &&
            !product.isSample
          " class="pli-product-promotions">
            <div v-for="appliedPromotion in product.appliedPromotions" :key="appliedPromotion.callOutMsg">
              {{ appliedPromotion.callOutMsg.markup }} {{ product.isBonusProductLineItem ? '' : appliedPromotion.amount }}
            </div>
          </div>

          <div v-if="isBoxProduct && !box.noMessage && box.giftMessage" class="pli-gift-box-message text-break">
            {{ box.giftMessage }}
          </div>
          <div v-if="isBoxProduct && actionURLs['BYOS-Landing']" class="product-edit">
            <a :href="`${actionURLs['BYOS-Landing']}?action=edit&key=${box.key}&cgid=${box.categoryId}&pgId=review&uuid=${product.UUID}`"
              class="secondary-link" :aria-label="$t('text.edit.line.item', [product.productName])"
              :title="$t('link.edit.item')">
              <span v-html="$t('link.edit.box')"></span>
            </a>
          </div>
          <!-- ProductPromotions -->
        </div>

        <!-- ProductPrice -->
        <div class="pli-price-container-wrapper">
          <div class="pli-product-price-container">
            <div :class="[
              'pli-product-price',
              product.isSample ? 'invisible' : '',
            ]">
              <span v-if="product.isSample || product.isBonusProductLineItem">
                <span v-html="freePrice"></span>
              </span>
              <span v-else :class="
                isBoxProduct
                  ? box.boxedUnadjustedPrice && box.boxedUnadjustedPrice !== box.boxedProductPrice
                    ? 'adjusted-price'
                    : ' '
                  : product.priceTotal.nonAdjustedPrice
                    ? 'adjusted-price'
                    : ''
              ">
                {{
                  isBoxProduct
                  ? box.boxedProductPrice
                                : product.priceTotal.price
                }}
              </span>
            </div>

            <div
              v-if="!product.isSample && !product.isBonusProductLineItem && (!isBoxProduct && product.priceTotal.nonAdjustedPrice || isBoxProduct && box.boxedUnadjustedPrice !== box.boxedProductPrice)"
                class="strike-through" :aria-label="`${$t('reduced.from')} ${isBoxProduct ? box.boxedUnadjustedPrice : product.priceTotal.nonAdjustedPrice} ${$t('reduced.to')} ${isBoxProduct ? box.boxedProductPrice : product.priceTotal.price}`">
              {{
                isBoxProduct
                ? box.boxedUnadjustedPrice : product.priceTotal.nonAdjustedPrice
              }}
            </div>
          </div>
        </div>
        <!-- ProductPrice -->
      </div>
      <ProductRefill v-if="
        SorEnabled &&
        product.isSORProduct &&
        !product.isBonusProductLineItem &&
        !product.isSample &&
        !isBoxProduct &&
        ((!cart.isFreshEmployee && !cart.isLVMHEmployee) || (((cart.isFreshEmployee && cart.isMemeberOfEmployeeDiscountCustomerGroup) || cart.isLVMHEmployee) && allowEmployeeForReplenishment)) &&
        !isOnCheckoutPage
      " :productProps="product" />

      <BundleLineItem v-if="
        product.bundledProductLineItems &&
        product.bundledProductLineItems.length > 0
      " :bundledProducts="product.bundledProductLineItems" :productUuid="product.UUID" />

      <!-- HazardousIcon -->
      <div v-if="isHazardousMaterial || (isExcludedProduct && product.bundledProductLineItems)" class="hazardous-alert-icon-wrapper">
        <svg class="hazardous-alert-icon">
          <use :href="`${svgPath}#hazardous-alert`" />
        </svg>
      </div>
      <!-- HazardousIcon -->

      <!-- Restricted shipping items -->
       <div v-if="isExcludedProduct && !product.bundledProductLineItems" class="pli-product-restricted">
          <span>{{ excludedProductMessage }}</span>
       </div>
      <!-- Restricted shipping items -->

    </div>
    <div class="pli-first-container">
      <!-- ProductImage  -->
      <a @click="imageHref($event)" :class="`pli-image-wrapper ${
        isBoxProduct || isSample || isBonusProduct  ? 'pli-disabled' : ''
      }`" :href="isBoxProduct || isSample || isBonusProduct ? '/' : product.url"
      :aria-label="!isSample && !isBonusProduct && !isBoxProduct ? product.productName + (product.priceTotal.nonAdjustedPrice ? ' ' + $t('reduced.from') + ' ' +  product.priceTotal.nonAdjustedPrice + ' ' + $t('reduced.to') + ' ' + product.priceTotal.price : '') : null"
      >
        <img v-if="product.imagesCart && product.imagesCart.cart_thumbnail && product.imagesCart.cart_thumbnail[0].url"
          class="pli-image" :src="product.imagesCart.cart_thumbnail[0].url"
          :alt="product.imagesCart.cart_thumbnail[0].alt" :title="product.imagesCart.cart_thumbnail[0].title" />
      </a>
      <!-- ProductImage  -->

      <!-- Select Quantity -->
      <div v-if="!isBoxProduct && !isOnCheckoutPage" class="select-and-remove-wrapper">
        <div v-if="!product.isSample && !product.isBonusProductLineItem && !product.engravingPLI_UUID"
          class="position-relative">
          <select :ref="`pliQtySelect-${product.id}`" :id="`pliQtySelect-${product.UUID}`" class="pli-qty-select-button form-control"
            v-bind:value="realProductQty" :aria-label="$t('button.change.quantity')" @change="onChangeQuantity($event)">
            <option v-for="option in selectOptions" :value="option" :key="option">
              {{ option }}
            </option>
          </select>
          <label class="form-control-placeholder" :for="`pliQtySelect-${product.UUID}`" v-html="$t('label.quantity')"></label>
          <svg class="chevron-down">
            <use :href="`${svgPath}#chevron-new`" />
          </svg>
        </div>
        <!-- Select Quantity -->

        <!-- ProductRemove -->
        <button v-if="
          !isInjectedBonusProduct &&
          !product.isSample &&
          !product.isBonusProductLineItem
        " @click="removeProductLineItem(product.id, product.UUID)" class="btn pli-remove-button"
          :aria-label="$t('label.remove')">
          <span v-html="$t('label.remove')"></span>
          <!-- <span aria-hidden="true">×</span> -->
        </button>
        <!-- ProductRemove -->
      </div>

      <button v-else-if="!isOnCheckoutPage" @click="removeProductLineItem(product.id, product.UUID)"
        class="btn pli-remove-button gift-box-remove" :aria-label="$t('label.remove')">
        <span v-html="$t('label.remove')"></span>
      </button>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/scripts/event-bus.js";
import { mapGetters, mapActions, mapState } from "vuex";
import ProductRefill from "./ProductRefill";
import BundleLineItem from "./BundleLineItem";
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { mapGetters as vue3_mapGetters } from "@/store/helper/vuex";

export default {
  name: "ProductLineItem",
  components: {
    ProductRefill,
    BundleLineItem
  },
  setup() {
    const { vueVariables } = vue3_mapGetters();
    const { paths } = window.vue;
    const route = useRoute();

    const isOnCheckoutPage = computed(() => { return route ? route.path.includes(paths['/checkout']) : false });

    return {
      isOnCheckoutPage,
      vueVariables
    };
  },
  data() {
    return {
      freePrice: this.vueVariables.freePrice,
      allowEmployeeForReplenishment: window.vue.customPreferences.allowEmployeeForReplenishment,
      SorEnabled: window.vue.customPreferences.SorEnabled,
    };
  },
  props: {
    product: {
      type: Object,
      required: true,
    },

    box: {
      type: Object,
      required: false,
    },
  },
  methods: {
    // isInjectedBonusProduct(product) {
    //   let injectedBonusProduct =
    //     this.cart.BonusLineItemContainer[0].bonusLinesInCart.find(
    //       (pid) => pid == product.id
    //     );
    //   return injectedBonusProduct ? true : false;
    // },

    imageHref(event) {
      this.isBoxProduct || this.isSample ? event.preventDefault() : null;
    },
    isAGiftProduct(product) {
      return (
        this.isByosPresent &&
        this.cart.boxContents.byosPidsQtys.boxPids.indexOf(product.id) > -1 &&
        !product.isBonusProductLineItem
      );
    },
    removeProductLineItem(id, uuid) {
      this.removeProduct({
        pid: id,
        uuid: uuid,
        key: this.isBoxProduct ? this.box.key : undefined,
        quantity: this.realProductQty,
        rawPrice: this.isBoxProduct ? this.box.boxedRawPrice : undefined
      }).then(() => { });
    },
    isNormalProduct: function (product) {
      return !product.isSample && !product.isBonusProductLineItem;
    },
    ...mapActions({
      removeProduct: "removeProduct",
      updateLineItemQuantity: "updateLineItemQuantity",
    }),
    onChangeQuantity(event) {
      let options = [];
      if (this.product.isSORProduct) {
        options = [
          {
            optionId: "FRESH_replenishmentOption",
            selectedValueId: this.isSORSelected ? "001" : "000",
          },
        ];
      }
      var form = {
        uuid: this.product.UUID,
        pid: this.product.id,
        quantity: event.target.value,
        options: options == [] ? null : JSON.stringify(options),
      };
      var bodyFormData = new FormData();

      for (var property in form) {
        bodyFormData.append(property, form[property]);
      }

      let productRefillInfo = {
        isSORSelected: this.isSORSelected,
        isSORProduct: this.product.isSORProduct,
        hasSmartOrderRefill: this.product.hasSmartOrderRefill,
        everyDelivery: this.product.SorPeriodicity
          ? this.product.SorPeriodicity
          : "",
        SorDeliveryWeekInterval: this.product.SorWeekInterval,
        SorDeliveryMonthInterval: this.product.SorMonthInterval,
        liuuid: this.product.UUID,
      };

      let payload = {
        editProductLineItemForm: bodyFormData,
        productRefillInfo: productRefillInfo,
      };

      this.updateLineItemQuantity(payload).then((data) => {
        let currentPliQtySelect = `pliQtySelect-${this.product.id}`;
        if (data.errorMessage) {
          this.$refs[currentPliQtySelect].value = this.realProductQty;
        }
      });
    },
    prodContainerisInjectedBonusProduct(product) {
      if (this.cart.BonusLineItemContainer.length == 0) return true;

      let injectedBonusProduct =
        this.cart.BonusLineItemContainer[0].bonusLinesInCart.find(
          (pid) => pid == product.id
        );
      return injectedBonusProduct ? false : true;
    },
    isGiftDummyItem(product) {
      return product.id === this.giftBoxItemID;
    },
    isAlsoInAGiftBox(product) {
      if (!this.isByosPresent) return false;
      return product.isInGiftBox;
    },
  },
  computed: {
    isInGiftBox: function () {
      return this.product.isInGiftBox;
    },

    isByosPresent: function () {
      return (
        this.cart.boxContents &&
        this.cart.boxContents.byosPidsQtys &&
        this.cart.boxContents.byosPidsQtys.pidQtys
      );
    },

    isOutOfStock: function () {
      return !this.product.available
    },

    isMaxQuantityExceed: function () {
      return this.product.available && this.product.quantity > this.product.quantityOptions.maxOrderQuantity;
    },

    isNormalBonusProduct: function () {
      if (this.cart.BonusLineItemContainer.length == 0) return false;
      return this.cart.BonusLineItemContainer[0].bonusLinesInCart.find(
        (pid) => pid == this.product.id
      )
        ? true
        : false;
    },
    isInjectedBonusProduct: function () {
      return this.product.isBonusProductLineItem && !this.isNormalBonusProduct;
    },
    isBoxProduct: function () {
      return this.box ? true : false;
    },
    isSample: function () {
      return this.product.isSample ? true : false;
    },
    isHazardousMaterial: function () {
      return this.box ? this.box.hasHazardousMaterial : this.product.isHazardousMaterial;
    },
    isExcludedProduct: function () {
      return this.box ? this.box.hasExcludedProducts : this.product.isExcludedProduct;
    },
    isBonusProduct: function () {
      return this.product.isBonusProductLineItem ? true : false;
    },
    ...mapState(["svgPath", "actionURLs"]),
    ...mapGetters({
      cart: "cart",
    }),
    isByosPresent: function () {
      return (
        this.cart.boxContents &&
        this.cart.boxContents.byosPidsQtys &&
        this.cart.boxContents.byosPidsQtys.pidQtys
      );
    },
    excludedProductMessage: function () {
      return this.box ? this.box.excludedProductMessage : this.product.excludedProductMessage;
    },
    selectOptions: function () {
      let maxOrderQuantity = this.product.quantityOptions.maxOrderQuantity;
      let selectOptionArray = Array.from({ length: maxOrderQuantity }, (_, index) => index + 1);

      if (this.product.quantity > maxOrderQuantity)
        selectOptionArray.push(this.product.quantity);

      return selectOptionArray;
    },
    realProductQty: function () {
      return this.isBoxProduct ? 1 : this.product.quantity;
    },
    isSORSelected: function () {
      return (
        this.product.SorPeriodicity !== undefined &&
        this.product.SorPeriodicity !== null
      );
    },
    isPriceMissing: function () {
      return this.box ? this.box.missingPrice : this.product.priceTotal.decimalPrice === null;
    }
  },
  created() { },
};
</script>

<style >

</style>
